import React from "react";

import { Link } from "@jsluna/link";

import {
  Notification,
  NotificationStatuses,
  trackEvent,
} from "@jsainsburyplc/id-ui-common";

import { categoryTypes, actionTypes } from "constants/tracking";
import { DENIED_IOVATION_RESPONSE } from "constants/codes";
import { missionId } from "utils/urls";
import { withMetaData } from "selectors";

const trackRequestForHelp = () => {
  trackEvent({
    category: categoryTypes.LOGIN,
    action: actionTypes.ERROR,
    label: `${missionId}: DENIED_IOVATION_RESPONSE - ${DENIED_IOVATION_RESPONSE}`,
  });
};

const AccountBlockedIovation = () => {
  const metadata = withMetaData();
  const defaultMission = "gol";
  const missionMapperLink = {
    gol: {
      link: (
        <Link
          cta
          bare
          color="alpha"
          data-testid="contact-support"
          href={`tel:${metadata && metadata.call_centre_number}`}
          onClick={trackRequestForHelp}
        >
          {metadata && metadata.call_centre_number}
        </Link>
      ),
      errorCode: "7135JSO",
    },
    nectar: {
      link: (
        <Link
          cta
          bare
          color="alpha"
          data-testid="contact-support"
          href={`tel:${metadata && metadata.call_centre_number}`}
          onClick={trackRequestForHelp}
        >
          Nectar Live Chat
        </Link>
      ),
      errorCode: "7135NEC",
    },
  };

  const getMissionMapperLink = (missionId) =>
    missionMapperLink[missionId]
      ? missionMapperLink[missionId].link
      : missionMapperLink[defaultMission].link;

  const getMissionMapperErrorCode = (missionId) =>
    missionMapperLink[missionId]
      ? missionMapperLink[missionId].errorCode
      : missionMapperLink[defaultMission].errorCode;

  return (
    <>
      <div className="c-hero c-hero--center">
        <h2>Your account is not available right now</h2>
      </div>
      <div className="ln-u-soft ln-u-text-align-center">
        <Notification type={NotificationStatuses.warning}>
          <p>
            For security reasons, your account is currently blocked. To access
            your account again, please contact our team on{" "}
            {getMissionMapperLink(missionId)}.
          </p>
          <p>
            Error code:{" "}
            <span className="ln-u-button">
              {getMissionMapperErrorCode(missionId)}
            </span>
          </p>
        </Notification>
      </div>
    </>
  );
};

export default AccountBlockedIovation;
